<template>
  <v-card class="overtile rounded-0" color="#37383A" :outlined=getOutlined>
    <div class="surround">
      <div
        class="perspective-text"
        v-prlx="{
          speed: 0.5,
          reverse: true,
          limit: { min: -200, max: 30 },
          disabled: useParallax,
        }"
      >
        <div class="perspective-line">
          <h2 class="blur title">{{ script.title }}</h2>
          <br />
          <p class="blur2">{{ script.scriptFill1 }}</p>
          <br />

          <div class="" v-bind:key="line.id" v-for="line in script.lines">
            <p v-if="line.speaker" class="author">{{ line.speaker }}</p>
            <v-col v-if="line.text" class="line"></v-col>
            <p v-if="line.text" class="clear">{{ line.text }}</p>
            <br />
          </div>
          <br />
          <p class="blur2">{{ script.scriptFill2 }}</p>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "ScriptTile",
  props: ["script"],
  computed: {
    getOutlined() {
      return new Boolean(false);
    },
    getHeight() {
      const { mdAndDown } = this.$vuetify.breakpoint;
      return mdAndDown ? 350 : 400;
    },
    getWidth() {
      const { mdAndDown } = this.$vuetify.breakpoint;
      return mdAndDown ? 400 : 800;
    },
    useParallax() {
      const { xsOnly } = this.$vuetify.breakpoint;
      console.log("here:" + xsOnly);
      return xsOnly ? true : false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Teko:wght@700&display=swap");
@import "~vuetify/src/styles/settings/_variables.scss";

@import url("https://fonts.googleapis.com/css2?family=Fauna+One&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Courier+Prime&display=swap");

.overtile {
  position: relative;
  bottom: -100px;
  overflow: hidden;
  margin-top: -130px;
  box-shadow: -26px 29px 13px -6px rgba(0, 0, 0, 0.6);
}

.surround {
  display: flex;
  justify-content: center;
  background: #f1f1f1;
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
  width: 600px;
  max-height: 350px;

  @media #{map-get($display-breakpoints, 'xs-only')} {
    max-height: 270px;
  }
}

.perspective-text {
  color: black;
  font-family: "Courier Prime", monospace;
  font-size: 18px;
  font-weight: 100;
  margin-top: -40px;
  margin-left: 10px;

  @media #{map-get($display-breakpoints, 'xs-only')} {
    margin-top: -50px;
    margin-left: -200px;
    font-size: 12px;
  }
}

.perspective-line {
  max-width: 550px;
  transform: skew(25deg, -4deg) scaleY(0.667);
}

.clear {
  max-width: 450px;
  @media #{map-get($display-breakpoints, 'xs-only')} {
    max-width: 250px;
  }
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}

p {
  margin: 0;
}

.title {
  text-align: center;
}
.author {
  max-width: 450px;
  text-align: center;
  font-weight: 900;
}
.blur {
  filter: blur(2px);
  max-width: 550px;
}

.blur2 {
  filter: blur(1px);
  max-width: 550px;
}
</style> 